import { Environment } from './environments'

const protocol = 'https://'
const baseUrl = 'anypoint.mulesoft.com'

export const getOrigin = (env: Environment) => {
  switch (env) {
    case Environment.LOCAL:
      return window.location.origin
    case Environment.PROD:
      return `${protocol}${baseUrl}`
    case Environment.PROD_EU:
      return `${protocol}eu1.${baseUrl}`
    default:
      return `${protocol}${env.toString().toLocaleLowerCase()}x.${baseUrl}`
  }
}
